export default "__VITE_ASSET__f66fcf6b__"